module.exports = __webpack_public_path__ + "img/Search.e983ec18.svg";